import { render } from "./ConsultaSwitch.vue?vue&type=template&id=bea57ca4"
import script from "./ConsultaSwitch.vue?vue&type=script&lang=js"
export * from "./ConsultaSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__